import { render, staticRenderFns } from "./indexs.vue?vue&type=template&id=64450322&scoped=true&"
import script from "./indexs.vue?vue&type=script&lang=ts&"
export * from "./indexs.vue?vue&type=script&lang=ts&"
import style0 from "./indexs.vue?vue&type=style&index=0&id=64450322&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64450322",
  null
  
)

export default component.exports